<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Editar Variação
        </span>
      </h3>
    </div>
    <Form url="/variavel/update" :variacao="variacao" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app-variacao-update",
  data() {
    return {
      variacao: {},
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getVariacao(id_variavel) {
      try {
        const response = await this.$http.post("/variavel/find", {
          id_variavel,
        });
        const data = (response.data);
        return {
          ...data,
        };
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id_variavel;

        this.setLoading(true);

        const variacao = await this.getVariacao(codigo);

        if (!variacao.id_variavel || variacao == null) {
          this.$router.push({ name: "variacoes" });
          return this.$toast.error("Variação não encontrada!");
        }

        this.variacao = variacao;
        this.setLoading(false);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
</script>
